module.exports = __webpack_public_path__ + "static/media/user-nft-20.0d008b91.jpg";